import React from 'react';
import { Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withAuth0 } from '@auth0/auth0-react';
import { loginAuth0UserAction, authErrorAction } from '../../../actions';

class Validate extends React.Component {
  getToken() {
    if (process.env.REACT_APP_ENVIRONMENT_NAME === 'cypress') {
      const userData = JSON.parse(localStorage.getItem('user'));
      this.props.loginAuth0UserAction(
        userData.jwt,
        this.props.onLogin,
        this.authError
      );

      return;
    }

    const { getAccessTokenSilently } = this.props.auth0;

    getAccessTokenSilently({
      audience: `Strut Backend API`,
    })
      .then((jwt) => {
        if (jwt)
          this.props.loginAuth0UserAction(
            jwt,
            this.props.onLogin,
            this.authError
          );
      })
      .catch((error) => {
        this.props.authErrorAction(error.message);
        this.authError();
      });
  }

  authError = () => {
    this.props.history.push('/logout');
  };

  componentDidMount() {
    this.getToken();
  }

  render() {
    return (
      <div className="loadingIndicatorContainer">
        <Spinner animation="border" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    errorMessage: state.auth.errorMessage,
  };
}

export default connect(mapStateToProps, {
  loginAuth0UserAction,
  authErrorAction,
})(withAuth0(Validate));
